import AuditTrailPage from "../../../components/AuditTrailPage";
import { HR_TABS } from "../../../utils/TabbarData";

const HrAuditTrail = () => {
  return (
    <AuditTrailPage
      role="HR"
      tabs={HR_TABS}
      selectedTabId={6}
      tabType="Audit Trail"
    />
  );
};

export default HrAuditTrail;
